import InterviewsListPage from './interviews-list-page'

export default InterviewsListPage